export const hrCalendarEventsFilters = {
  all: {
    label: 'Tutti',
    filters: {},
  },
  active: {
    label: 'Attivi',
    filters: {
      isActive: true,
    },
  },
  inactive: {
    label: 'Non attivi',
    filters: {
      isActive: false,
    },
  },
} as const;
